/* global jQuery, js_vars, elementorFrontend, Headroom, Mmenu */

/*--------------------------------------------------------------------------------
General Ready
--------------------------------------------------------------------------------*/
(function ($) {
$(document).ready(function () {

	/*--------------------------------------------------------------------------------
	Utility: Hide element on click outside
	--------------------------------------------------------------------------------*/

	function hideOnClickOutside( selector, type = 'standard' ) {
		const outsideClickListener = (event) => {
			const $target = $(event.target);
			if( type == 'standard' ) {
				if ( ! $target.closest(selector).length ) {
					$(selector).removeClass('open');
					removeClickListener();
				}
			} else if( type == 'search' ) {
				if ( ! $target.closest('.site-header').length ) {
					$(selector).removeClass('open');
					removeClickListener();
				}
			}
		}

		const removeClickListener = () => {
			document.removeEventListener('click', outsideClickListener)
		}

		document.addEventListener('click', outsideClickListener)
	}


	/*--------------------------------------------------------------------------------
	Header Navigation
	--------------------------------------------------------------------------------*/

	let $siteHeader = $("#site-header");

	var options = {
		// vertical offset in px before element is first unpinned
		offset: {
			up : 0,
			down : $siteHeader.height() + 100,
		},
		tolerance : {
			up : 6,
			down : 0
		},
	};

	$("#site-header").headroom(options);


});
})(jQuery);


/*--------------------------------------------------------------------------------
Mobile Menu
--------------------------------------------------------------------------------*/
document.addEventListener(
	"DOMContentLoaded", () => {
		let mobileMenu = document.getElementById("mobile-menu");
		let mobileMenuMmenu = false;

		if( mobileMenu ) {

			// Prep mobile menu header actions
			const action_account = jQuery('.site-header__actions .action--account').clone();
			const action_cart = jQuery('.site-header__actions .action--cart').clone();

			// Build mobile menu action HTML
			let mobileActions = jQuery("<div id='navigation-actions--mobile' class='navigation-actions--mobile'></div>");
			mobileActions.append(action_account, action_cart);

			// Init Mmenu
			mobileMenuMmenu = new Mmenu( "#mobile-menu", {
				"offCanvas": {
					"clone": "true",
					"position": "right"
				},
				"theme": "light",
				"navbars": [
					// {
					// 	"position": "top",
					// 	"content": [
					// 		mobileActions[0],
					// 		"close"
					// 	]
					// },
					{
						"position": "top",
						"content": [
							"prev",
							"close"
							// "title"
						]
					},
				],
				hooks: {
					"openPanel:after": ( panel ) => {
						let nav_top = document.getElementById("mobile-menu");

						// jQuery('#site-header__mobile-button').toggleClass('is-active');

						// jQuery('#navigation-actions--mobile').html(nav_actions);
						// jQuery('#navigation-actions--mobile').append(action_search, action_account, action_cart);

						// if( panel.id == 'mm-1' ) {
						// 	nav_top.classList.add("mm-home");
						// 	jQuery(nav_top).find('.mm-navbar__title').parent('.mm-navbar').addClass('menu-hidden');
						// } else {
						// 	nav_top.classList.remove("mm-home");
						// 	jQuery(nav_top).find('.mm-navbar__title').parent('.mm-navbar').removeClass('menu-hidden');
						// }
					},
					"closePanel:after": ( panel ) => {
						// jQuery('#site-header__mobile-button').removeClass('is-active');
					}
				}
			});
		}

		mobileMenuMmenu.bind('open:after', function () {
			jQuery('.site-header__mobile-button').addClass('is-active');
		});

		mobileMenuMmenu.bind('close:after', function () {
			jQuery('.site-header__mobile-button').removeClass('is-active');
		});
		
		function windowResizeMmenu() {
			let windowWidth = jQuery(window).width();
			if( windowWidth > 1080 && mobileMenuMmenu ) {
				mobileMenuMmenu.close();
			}
		}
	
		jQuery(window).resize(function(){ windowResizeMmenu(); });
	}
);